import { CardErrorMessage, Table } from '../util';
import { createTimezonedDate } from '../util/date';
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { makeKey } from '../hooks/useConvertForTranslationKey';
const dateToLocale = date => {
  return createTimezonedDate(new Date(date)).toCustomLocaleTimeString();
};
const sortByDate = (a, b) => {
  if (a.created_at < b.created_at) {
    return 1;
  }
  if (a.created_at > b.created_at) {
    return -1;
  }
  return 0;
};
const downloadLinkOrPendingStatus = snapshot => {
  if (snapshot.rnd_report.pdf_generation_status !== 'success') {
    return /*#__PURE__*/React.createElement("div", null, "Please wait while PDF is being generated");
  } else {
    return /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("a", {
      href: snapshot.link_to_file,
      target: "_blank",
      rel: "noreferrer",
      download: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "fa fa-download"
    }), " Download"));
  }
};
const status = (snapshotStatus, changeSetReviewType, t) => {
  const statusInfo = {
    consultant_review: {
      approved: {
        text: 'Accepted all outstanding changes and closed the review',
        icon: 'done'
      },
      rejected: {
        text: 'Rejected changes and closed review',
        icon: 'close'
      },
      finalized: {
        text: 'Completed Their Manager Review',
        icon: 'zoom_in'
      },
      started: {
        text: 'Started Manager QA Review',
        icon: 'engineering'
      }
    },
    client_review: {
      approved: {
        text: 'Accepted all outstanding changes and closed the review',
        icon: 'done'
      },
      rejected: {
        text: 'Rejected changes and closed review',
        icon: 'close'
      },
      finalized: {
        text: 'Client Review Completed by Manager/Consultant',
        icon: 'zoom_in'
      },
      started: {
        text: 'Started Client QA Review',
        icon: 'engineering'
      }
    }
  };
  return /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, statusInfo[changeSetReviewType][snapshotStatus].icon), " ", t(makeKey(statusInfo[changeSetReviewType][snapshotStatus].text)));
};
const ObjectChangeSetsListWithSnapshots = _ref => {
  let {
    object,
    reviewType,
    resetData,
    showAllReviewTypes = false
  } = _ref;
  const [intervalId, setIntervalId] = useState(null);
  const {
    t
  } = useTranslation();
  const everyReportIsSuccess = object.change_sets.every(c => c.report_snapshots.every(s => s.rnd_report.pdf_generation_status === 'success'));
  useEffect(() => {
    if (everyReportIsSuccess) {
      if (intervalId) {
        resetData();
        window.clearInterval(intervalId);
        setIntervalId(null);
      }
    } else {
      if (!intervalId) {
        const intervalId = window.setInterval(() => {
          resetData();
        }, 2000);
        setIntervalId(intervalId);
      }
    }

    // clear any left interval on component dismount
    return () => window.clearInterval(intervalId);
  }, [everyReportIsSuccess, intervalId, resetData]);
  const rows = object.change_sets.filter(changeSet => showAllReviewTypes || changeSet.review_type === reviewType).sort(sortByDate).map(changeSet => {
    return changeSet.report_snapshots.sort(sortByDate).map(snapshot => {
      return {
        columns: [dateToLocale(snapshot.status_datetime), changeSet.author.name, status(snapshot.status, changeSet.review_type, t), downloadLinkOrPendingStatus(snapshot)]
      };
    });
  }).flat();
  if (!object.change_sets.length) {
    return /*#__PURE__*/React.createElement(CardErrorMessage, {
      errorMessage: t('no_changes_for_this_object_yet')
    });
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    className: "scrollable",
    style: {
      height: '220px'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Table, {
    className: "table-scrollable-x",
    headers: [],
    rows: rows,
    showControls: false
  }))));
};
export default ObjectChangeSetsListWithSnapshots;